import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type Store from '@ember-data/store'
import type SessionService from 'district-ui-client/services/session'
import type ManageStudentsIndexController from 'district-ui-client/subscription-type/manage/students/index/controller'
import type SubscriptionTypeRoute from 'district-ui-client/subscription-type/route'
import type School from 'district-ui-client/models/school'
import type Teacher from 'district-ui-client/models/teacher'
import { hasId } from 'district-ui-client/utils/type-guards'

export default class ManageStudentsIndexRoute extends Route {
  @service store!: Store

  @service session!: SessionService

  queryParams = {
    schoolId: {
      replace: false,
    },
    teacherId: {
      replace: false,
    },
    schoolClassId: {
      replace: false,
    },
    studentFirstName: {
      replace: false,
    },
    studentLastName: {
      replace: false,
    },
  }

  async model() {
    const { subscriptionType } = this.modelFor('subscription-type') as ModelFor<SubscriptionTypeRoute>
    const [schools, teachersForSubType] = await Promise.all([
      this.store.query<School>('school', {
        scope: `districts/${this.session.currentDistrict.id}`,
        // @ts-expect-error - include types not correct
        include: 'school-subscriptions',
      }),
      // used to make teacher options for searching by
      this.store.query<Teacher>('teacher', {
        filter: { 'subscription-type': subscriptionType },
        scope: `districts/${this.session.currentDistrict.id}`,
        // need the school<->teachers relation present, for the change school modal
        // @ts-expect-error - include types not correct
        include: 'school-classes,school',
      }),
    ])
    const has3ESchool = schools.some((school) => school.oneRosterEnabledAt)
    const schoolsForSubType = schools.filter((school) => school.hasActiveSchoolSubscriptionFor(subscriptionType))
    return {
      schoolsForSubType: schoolsForSubType.filter(hasId),
      teachersForSubType: teachersForSubType.filter(hasId),
      has3ESchool,
    }
  }

  resetController(controller: ManageStudentsIndexController, isExiting: boolean) {
    if (isExiting) controller.updateSelectedIds?.([])
  }
}
